module.exports = __webpack_public_path__ + "img/T722.180a9267.jpg";